
/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';
import { createOpenModalAction } from 'state/ui/actions';
import { isModalVisible } from 'state/ui/selectors';


const openModal = createOpenModalAction('OperationDetailsModal');

export const startOperationDetailsModal = (operationId) => dispatch => {
    dispatch({
        type: actions.START_OPERATION_DETAILS_MODAL,
        payload: { operationId }
    })
    dispatch(openModal());
}